import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const UserOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.23 7.89a2.83 2.83 0 1 1 5.66 0 2.83 2.83 0 0 1-5.66 0Zm2.83-4.43a4.43 4.43 0 0 0-2.676 7.96c-3.609.777-6.374 3.837-6.374 7.54v.78a.8.8 0 0 0 1.6 0v-.78c0-3.322 2.915-6.13 6.57-6.13h1.66c3.655 0 6.57 2.808 6.57 6.13v.78a.8.8 0 0 0 1.6 0v-.78c0-3.676-2.726-6.72-6.296-7.523A4.43 4.43 0 0 0 12.06 3.46Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default UserOutlined
